import * as colors from '../../utils/colorCodes'

export const HomeIcon = ({ width, height }) => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={width ? width : 18}
                height={height ? height : 20}
                viewBox="0 0 18 20"
            >
                <path
                    id="Vector"
                    d="M2.25,20a2.149,2.149,0,0,1-1.589-.671A2.219,2.219,0,0,1,0,17.715V7.429A2.3,2.3,0,0,1,.24,6.4,2.179,2.179,0,0,1,.9,5.6L7.65.457A2.361,2.361,0,0,1,8.3.114,2.22,2.22,0,0,1,9.7.114a2.362,2.362,0,0,1,.647.343L17.1,5.6a2.189,2.189,0,0,1,.662.8A2.3,2.3,0,0,1,18,7.429V17.715a2.221,2.221,0,0,1-.66,1.615A2.152,2.152,0,0,1,15.75,20h-4.5V12H6.75v8Z"
                    fill={colors.PRIMARY_YELLOW}
                    style={{ mixBlendMode: "normal", isolation: "isolate" }}
                />
            </svg>
        </>
    );
};
export const WorkIcon = ({ width, height }) => {
    return (
        <>
            <svg xmlns="http://www.w3.org/2000/svg" width={width ? width : "25.532"} height={height ? height : "25.532"} viewBox="0 0 25.532 25.532">
                <g id="offers" transform="translate(0 0)">
                    <path id="Path_15" data-name="Path 15" d="M206.52,151.983,205.18,150.2l-.744,5.212a2.258,2.258,0,0,1-.635,1.269l-9.168,9.168a4.21,4.21,0,0,1-3,1.24,4.278,4.278,0,0,1-.992-.117,2.742,2.742,0,0,0,2.312,1.269h10.971a2.746,2.746,0,0,0,2.743-2.743V152.432A.748.748,0,0,0,206.52,151.983Z" transform="translate(-181.137 -142.708)" fill={colors.PRIMARY_YELLOW} />
                    <circle id="Ellipse_7" data-name="Ellipse 7" cx="0.748" cy="0.748" r="0.748" transform="translate(14.688 10.931)" fill={colors.PRIMARY_YELLOW} />
                    <circle id="Ellipse_8" data-name="Ellipse 8" cx="0.748" cy="0.748" r="0.748" transform="translate(6.225 10.931)" fill={colors.PRIMARY_YELLOW} />
                    <path id="Path_16" data-name="Path 16" d="M12.439,22.081l9.168-9.168a.748.748,0,0,0,.212-.423l1.058-7.4a.748.748,0,0,0-.212-.635L21.078,2.864,18.962,4.979l.529.529a.748.748,0,1,1-1.058,1.058L16.317,4.45a.748.748,0,0,1,1.058-1.058l.529.529L20.02,1.806,18.433.219A.749.749,0,0,0,17.8.007l-7.4,1.058a.748.748,0,0,0-.423.212L.8,10.445a2.746,2.746,0,0,0,0,3.879L8.56,22.081a2.746,2.746,0,0,0,3.879,0Zm3-12.646a2.244,2.244,0,1,1-2.244,2.244A2.247,2.247,0,0,1,15.436,9.435ZM6.973,13.923a2.244,2.244,0,1,1,2.244-2.244A2.247,2.247,0,0,1,6.973,13.923Zm2.468,3.793a.748.748,0,0,1-.71-.985L12.258,6.153a.748.748,0,0,1,1.419.473L10.151,17.2A.748.748,0,0,1,9.441,17.716Z" fill={colors.PRIMARY_YELLOW} />
                    <path id="Path_17" data-name="Path 17" d="M404.1,1.277A.748.748,0,0,0,403.044.219l-1.587,1.587,1.058,1.058Z" transform="translate(-381.437 0)" fill={colors.PRIMARY_YELLOW} />
                </g>
            </svg>
        </>
    );
};
export const OtherIcon = ({ width, height }) => {
    return (
        <>
            <svg xmlns="http://www.w3.org/2000/svg" width={width ? width : "19.682"} height={height ? height : "19.682"} viewBox="0 0 19.682 19.682">
                <g id="Layer_52" data-name="Layer 52" transform="translate(-3.25 -3.25)">
                    <path id="Path_40" data-name="Path 40" d="M18.568,3.25H7.614A4.368,4.368,0,0,0,3.25,7.614V18.568a4.368,4.368,0,0,0,4.364,4.364H18.568a4.368,4.368,0,0,0,4.364-4.364V7.614A4.368,4.368,0,0,0,18.568,3.25ZM7.758,14.861a1.77,1.77,0,1,1,1.773-1.77A1.77,1.77,0,0,1,7.758,14.861Zm5.333,0a1.77,1.77,0,1,1,1.77-1.77,1.77,1.77,0,0,1-1.77,1.77Zm5.333,0a1.77,1.77,0,1,1,1.77-1.77,1.77,1.77,0,0,1-1.77,1.77Z" fill={colors.PRIMARY_YELLOW} />
                </g>
            </svg>
        </>
    );
};

/**
 * Trash / remove icon. Stroked with `currentColor`, so it picks up whatever
 * colour its container sets - inside the quantity stepper (.qty .minus is
 * white on yellow) it renders white with no separate asset.
 */
export const TrashIcon = ({ width = 14, height = 14, strokeWidth = 2.5, ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        {...props}
    >
        <polyline points="3 6 5 6 21 6" />
        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
        <line x1="10" y1="11" x2="10" y2="17" />
        <line x1="14" y1="11" x2="14" y2="17" />
    </svg>
);

export const WhatsAppIcon = (props) => (
    <svg
        viewBox="0 0 682 682.667"
        xmlSpace="preserve"
        {...props}
    >
        <path
            fillRule="evenodd"
            d="M544.387 93.008C484.512 33.063 404.883.035 320.05 0 145.246 0 2.98 142.262 2.91 317.113c-.024 55.895 14.577 110.457 42.331 158.551L.25 640l168.121-44.102c46.324 25.27 98.477 38.586 151.55 38.602h.134c174.785 0 317.066-142.273 317.132-317.133.036-84.742-32.921-164.418-92.8-224.36zM320.05 580.94h-.11c-47.296-.02-93.683-12.73-134.16-36.742l-9.62-5.715-99.766 26.172 26.628-97.27-6.27-9.972c-26.386-41.969-40.32-90.476-40.296-140.281.055-145.332 118.305-263.57 263.7-263.57 70.406.023 136.59 27.476 186.355 77.3s77.156 116.051 77.133 186.485C583.582 462.69 465.34 580.94 320.05 580.94m144.586-197.418c-7.922-3.968-46.883-23.132-54.149-25.78-7.258-2.645-12.547-3.962-17.824 3.968-5.285 7.93-20.469 25.781-25.094 31.066-4.625 5.29-9.242 5.953-17.168 1.985-7.925-3.965-33.457-12.336-63.726-39.332-23.555-21.012-39.457-46.961-44.082-54.89-4.617-7.938-.04-11.813 3.476-16.173 8.578-10.652 17.168-21.82 19.809-27.105 2.644-5.29 1.32-9.918-.664-13.883-1.977-3.965-17.824-42.969-24.426-58.84-6.437-15.445-12.965-13.36-17.832-13.601-4.617-.231-9.902-.278-15.187-.278-5.282 0-13.868 1.98-21.133 9.918-7.262 7.934-27.73 27.102-27.73 66.106s28.394 76.683 32.355 81.972c3.96 5.29 55.879 85.328 135.367 119.649 18.906 8.172 33.664 13.043 45.176 16.695 18.984 6.031 36.254 5.18 49.91 3.14 15.226-2.277 46.879-19.171 53.488-37.68 6.602-18.51 6.602-34.374 4.617-37.683-1.976-3.304-7.261-5.285-15.183-9.254m0 0"
            fill="#fff"
            data-original="#000000"
        />
    </svg>
);

export const WhatsAppUnderlineGreen = (props) => (
    <svg
        width={48}
        height={48}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clipPath="url(#clip0_4050_577)">
            <path
                d="M0 48L3.374 35.674C1.292 32.066 0.198 27.976 0.2 23.782C0.206 10.67 10.876 0 23.986 0C30.348 0.002 36.32 2.48 40.812 6.976C45.302 11.472 47.774 17.448 47.772 23.804C47.766 36.918 37.096 47.588 23.986 47.588C20.006 47.586 16.084 46.588 12.61 44.692L0 48ZM13.194 40.386C16.546 42.376 19.746 43.568 23.978 43.57C34.874 43.57 43.75 34.702 43.756 23.8C43.76 12.876 34.926 4.02 23.994 4.016C13.09 4.016 4.22 12.884 4.216 23.784C4.214 28.234 5.518 31.566 7.708 35.052L5.71 42.348L13.194 40.386ZM35.968 29.458C35.82 29.21 35.424 29.062 34.828 28.764C34.234 28.466 31.312 27.028 30.766 26.83C30.222 26.632 29.826 26.532 29.428 27.128C29.032 27.722 27.892 29.062 27.546 29.458C27.2 29.854 26.852 29.904 26.258 29.606C25.664 29.308 23.748 28.682 21.478 26.656C19.712 25.08 18.518 23.134 18.172 22.538C17.826 21.944 18.136 21.622 18.432 21.326C18.7 21.06 19.026 20.632 19.324 20.284C19.626 19.94 19.724 19.692 19.924 19.294C20.122 18.898 20.024 18.55 19.874 18.252C19.724 17.956 18.536 15.03 18.042 13.84C17.558 12.682 17.068 12.838 16.704 12.82L15.564 12.8C15.168 12.8 14.524 12.948 13.98 13.544C13.436 14.14 11.9 15.576 11.9 18.502C11.9 21.428 14.03 24.254 14.326 24.65C14.624 25.046 18.516 31.05 24.478 33.624C25.896 34.236 27.004 34.602 27.866 34.876C29.29 35.328 30.586 35.264 31.61 35.112C32.752 34.942 35.126 33.674 35.622 32.286C36.118 30.896 36.118 29.706 35.968 29.458Z"

            />
        </g>
        <defs>
            <clipPath id="clip0_4050_577">
                <rect width={48} height={48} fill="white" />
            </clipPath>
        </defs>
    </svg>

);